import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintManageEntityList } from './';

/**
 * @component {kat-blueprint-manage-entity-list-overview} KatBlueprintManageEntityListOverview Component used to place and filter components within the overview section.
 * @slot default Blueprint content for overview section.
 */
@register(KatBlueprintManageEntityList.slotMapping.overview.name)
export class KatBlueprintManageEntityListOverview extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintManageEntityList.slotMapping.overview.name,
      KatBlueprintManageEntityList.slotMapping.overview.allowed
    );
  }
}
